export const THOUGHTSPOT_CONFIG = {
    THOUGHTSPOT_HOST_URL: process.env.THOUGHTSPOTTER_HOST_URL,
    THOUGHTSPOTTER_USERNAME: process.env.THOUGHTSPOTTER_USERNAME,
    THOUGHTSPOTTER_PASSWORD: process.env.THOUGHTSPOTTER_PASSWORD,
    THOUGHTSPOTTER_WORKSHEET_ID: process.env.THOUGHTSPOTTER_WORKSHEET_ID,
};

export const insightConstants = {
    INSIGHT_GET_LIST_OF_LIVEBOARD_REQUEST:
        "INSIGHT_GET_LIST_OF_LIVEBOARD_REQUEST",

    INSIGHT_GET_LIST_OF_LIVEBOARD_COMPLETE:
        "INSIGHT_GET_LIST_OF_LIVEBOARD_COMPLETE",

    INSIGHT_GET_LIST_OF_JOB_ROLES_AND_COUNT_REQUEST:
        "INSIGHT_GET_LIST_OF_JOB_ROLES_AND_COUNT_REQUEST",
    INSIGHT_GET_LIST_OF_JOB_ROLES_AND_COUNT_COMPLETED:
        "INSIGHT_GET_LIST_OF_JOB_ROLES_AND_COUNT_COMPLETED",

    INSIGHT_GET_DEALERS_SUMMARY_REQUEST: "INSIGHT_GET_DEALERS_SUMMARY_REQUEST",
    INSIGHT_GET_DEALERS_SUMMARY_COMPLETED:
        "INSIGHT_GET_DEALERS_SUMMARY_COMPLETED",

    SHERBOT_GET_AI_INSTRUCTION_REQUEST: "SHERBOT_GET_AI_INSTRUCTION_REQUEST",
    SHERBOT_GET_AI_INSTRUCTION_COMPLETED:
        "SHERBOT_GET_AI_INSTRUCTION_COMPLETED",
    SHERBOT_GET_AI_INSTRUCTION_ERROR: "SHERBOT_GET_AI_INSTRUCTION_ERROR",

    SHERBOT_UPDATE_AI_INSTRUCTION_REQUEST:
        "SHERBOT_UPDATE_AI_INSTRUCTION_REQUEST",
    SHERBOT_UPDATE_AI_INSTRUCTION_COMPLETED:
        "SHERBOT_UPDATE_AI_INSTRUCTION_COMPLETED",
    SHERBOT_UPDATE_AI_INSTRUCTION_ERROR: "SHERBOT_UPDATE_AI_INSTRUCTION_ERROR",
};
